import moment from 'moment'

export default defineNuxtPlugin({
  name: 'moment',

  parallel: true,

  setup() {
    return {
      provide: { moment },
    }
  },
})
